import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";
import { ItemType } from "../../models/ItemTypes";
import { data } from "react-router-dom";


export const ContributorUtils = () => {
    const [currencies, setCurrencies] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [gstCodes, setGstCodes] = useState<any[]>([]);

    const fetchCurrencies = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/currencymaster",
                searchKey: "name",
                searchTerm: inputValue,
                labelKey: "name",
                valueKey: "_id",
            }).then(setCurrencies);
        }, 500),
        []
    );

    const fetchCities = useCallback(
        debounce((inputValue) => {
          fetchDropDownData({
            endpoint: "/citymasters",
            searchKey: "cityName",
            searchTerm: inputValue,
            labelKey: "cityName",
            valueKey: "_id",
          }).then((data) => {
            console.log("city response from dropdown data: ", data);
            
            const formattedCityResponse = data.map((city: any) => ({
              label: city.cityName,
              value: city._id,
              stateName: city.stateId?.stateName || "" 
            }));
            
            console.log("city response: ", formattedCityResponse);
            setCities(formattedCityResponse);
          });
        }, 500),
        []
      );

    const fetchGstCodes = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/gststatecode",
                searchKey: "gstCode",
                searchTerm: inputValue,
                labelKey: "gstCode",
                valueKey: "gstCode", 
            }).then((data) => {
                const sortedData = data.sort((a, b) =>
                  a.value.localeCompare(b.value)
                );
                setGstCodes(sortedData);
              });
        }, 500),
        []
    );
    

    return { 
        currencies,
        setCurrencies,
        fetchCurrencies,
        cities,
        setCities,
        fetchCities,
        gstCodes,
        setGstCodes,
        fetchGstCodes
    };
};
